import React, {useContext} from "react";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import useAcl from "../../hooks/use-acl";
import {IRegionType, NpiInternalContext} from "../../contexts/internal-context";
import {Spin} from "antd";


interface IRegionProtectedRoute {
    redirectPath? : string;
    regionPermissions : keyof IRegionType
}

const RegionProtectedRoute = ({regionPermissions, redirectPath = '/npi'}: IRegionProtectedRoute): React.ReactElement => {

    const {loaded} = useContext(NpiInternalContext);
    const {hasRegionFeatureAccess} = useAcl();
    const userAccess: boolean = hasRegionFeatureAccess(regionPermissions);
    const location = useLocation();

    if (!loaded) {
        return <div style={{textAlign: 'center', padding: '30px 50px'}}>
            <Spin/>
        </div>
    }

    if (!userAccess) {
        return <Navigate to={{pathname: redirectPath}} state={{from: location}} replace />
    }

    return <Outlet />
}

export default RegionProtectedRoute;